(() => {
  const initStickyBuy = (root) => {
    if (!root || root.dataset.blazeStickyReady === 'true') return;

    const bar = root.querySelector('[data-blaze-sticky-buy]');
    if (!bar) return;

    root.dataset.blazeStickyReady = 'true';

    const stickyForm = root.querySelector('[data-blaze-sticky-form]');
    stickyForm?.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('button[type="submit"]') : null;
      if (!button || !stickyForm.contains(button) || document.body.dataset.blazePairedOfferEnabled !== 'true') return;

      const productId = stickyForm.dataset.productId;
      const offerChooser = Array.from(document.querySelectorAll('main product-form-component[data-blaze-paired-offer-form="true"]'))
        .find((component) => component.dataset.productId === productId)
        ?.querySelector('[data-blaze-offer-chooser]');
      if (!offerChooser) return;

      event.preventDefault();
      event.stopPropagation();
      offerChooser.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
      offerChooser.querySelector('[data-blaze-offer-select][aria-pressed="true"]')?.focus({ preventScroll: true });
    }, true);

    const targets = Array.from(
      document.querySelectorAll(
        '[data-blaze-buy-target], main product-form-component:not([data-blaze-sticky-form])'
      )
    ).filter((target) => !root.contains(target));

    if (!('IntersectionObserver' in window) || targets.length === 0) {
      bar.classList.remove('is-hidden');
      return;
    }

    const visibleTargets = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) visibleTargets.add(entry.target);
          else visibleTargets.delete(entry.target);
        });

        bar.classList.toggle('is-hidden', visibleTargets.size > 0);
      },
      { threshold: 0.18 }
    );

    targets.forEach((target) => observer.observe(target));
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-blaze-sticky-root]').forEach(initStickyBuy);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
